<p-button
  size="large"
  [label]="buttonLabel()"
  (click)="openDialog()"
  [loading]="isLoading()"
  [disabled]="disabled() || isLoading()"
  pTooltip="Upload a file with metadata"></p-button>

@if(displayDialog()){
<p-dialog
  header="Upload File"
  [(visible)]="displayDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{ width: '50vw', height: '50vh' }">
  <div class="upload-dialog">
    @if(!fileSelected()){
    <div class="file-input-container">
      <input #fileInput type="file" [id]="fileInputId" (change)="onFileSelected($event)" [accept]="accept()" style="display: none" />
      <p-button label="Select File" (click)="triggerFileInputClick(fileInput)"></p-button>
    </div>
    } @else {
    <div class="file-details">
      <p>File: {{ fileSelected()?.name }}</p>
      <p>Size: {{ fileSelected()?.size }} bytes</p>
    </div>

    <div class="metadata-container">
      <h5>Metadata</h5>
      <div class="p-fluid">
        @for (key of objectKeys(metadata()); track key) {
        <div class="p-field">
          <label [for]="key">{{ key }}</label>
          <input pInputText [id]="key" [(ngModel)]="metadataInput[key]" />
        </div>
        }

        <div class="p-field">
          <label for="emotion">Emotion</label>
          <p-select [options]="MoodStateOptions" [(ngModel)]="moodSelected" optionLabel="label" optionValue="value" placeholder="Select an emotion"></p-select>
        </div>
      </div>
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button label="Cancel" styleClass="p-button-secondary" (click)="displayDialog.set(false)"></p-button>
      <p-button label="Upload" (click)="uploadFile()" [disabled]="!fileSelected() || isLoading()"></p-button>
    </div>
  </ng-template>
</p-dialog>
}
